import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const LANGS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'hi', label: 'हिन्दी', flag: '🇮🇳' },
  { code: 'pa', label: 'ਪੰਜਾਬੀ', flag: '🇮🇳' },
];

export const LanguageSwitcher = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full hover:bg-gray-100 transition-colors text-sm font-bold text-black"
          data-testid="lang-switcher"
        >
          <Globe className="h-4 w-4" />
          {!compact && <span>{current.label}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-44 p-1" align="end">
        {LANGS.map((l) => (
          <button
            key={l.code}
            onClick={() => i18n.changeLanguage(l.code)}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm font-bold transition-colors ${
              i18n.language === l.code ? 'bg-[#FFE5EE] text-[#FF0059]' : 'text-black hover:bg-gray-50'
            }`}
            data-testid={`lang-option-${l.code}`}
          >
            <span>{l.flag}</span> {l.label}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
